define('c3_additional_levels_extralayer.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('c3_additional_levels_extralayer', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "testing";
},"useData":true}, 'extensions/C3/ShoppingExtensionsLatest/1.0.0/', 'extensions/C3/ShoppingExtensionsLatest/1.0.0/', Handlebars);
});